import { useCallback, useMemo } from "react"
import { useVenue } from "providers/venue"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useGeoLocation } from "providers/geolocation"
import _ from "lodash"

export const usePromotion = () => {
  const { promotions } = useVenue()
  const { locationVenue } = useGeoLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const locationVenueId = _.get(locationVenue, "id")

  const onChangeVenue = useCallback(
    (venueId) => {
      if (venueId) searchParams.set("venue", venueId)
      navigate(`/promotions/?${searchParams.toString()}`, { replace: true })
    },
    [navigate, searchParams]
  )

  const venueFilter = useMemo(
    () => searchParams.get("venue") || locationVenueId,
    [searchParams, locationVenueId]
  )

  const storePromotions = useMemo(
    () =>
      promotions?.filter(({ properties }) => properties.category === "store"),
    [promotions]
  )

  const viewingVenueStorePromotion = useMemo(
    () =>
      storePromotions?.filter(
        ({ properties }) => properties.venue_id === venueFilter
      ),
    [storePromotions, venueFilter]
  )

  return {
    storePromotions,
    viewingVenueStorePromotion,
    onChangeVenue,
    locationVenueId,
    venueFilter,
  }
}
